import request from '@/http/request';
import store from '@/store';

// const relayApi = store.getters.getConfigItem('relay_api');
console.log(`当前环境：${process.env.NODE_ENV}`);
const env = process.env.NODE_ENV === 'development' ? 'test' : 'product';

export function postRelay(path, params) {
  return request({
    url: `/relay${path}`,
    method: 'POST',
    data: {
      ...params,
      VueOperateUser: store.state.user.name,
    },
  });
}

// 请求到任意地址
export function postAny(url, params) {
  return request({
    url,
    method: 'POST',
    data: params,
  });
}


import axios from 'axios';

export const newformatApi = async (params) => {
  try {
    const response = await axios.post('/api/endpoint', params); // 你需要替换 '/api/endpoint' 为实际的 API 地址
    return response; // 确保返回的是 axios 的响应对象
  } catch (error) {
    console.error('API 请求错误:', error);
    return { data: null }; // 避免 data 访问时报错
  }
};
